// removed by extract-text-webpack-plugin
module.exports = {"container":"TatteredPageComponent__container___TrtyG","buttons":"TatteredPageComponent__buttons___1DVCG","spellButton":"TatteredPageComponent__spellButton___2YoUM","spellButtonOverlay":"TatteredPageComponent__spellButtonOverlay___tHTdF","activeSpell":"TatteredPageComponent__activeSpell___2U5Lb","close":"TatteredPageComponent__close___1GBM5","sandbox":"TatteredPageComponent__sandbox___DeOzx"};


//////////////////
// WEBPACK FOOTER
// ./src/game/menus/TatteredPageComponent.scss
// module id = 165
// module chunks = 0